import React from 'react';
import PropTypes from 'prop-types';
// import deburr from 'lodash/deburr';
import Downshift from 'downshift';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
// import Popper from '@material-ui/core/Popper';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
// import Chip from '@material-ui/core/Chip';

// API
import api from '../api/coins/api'
// api exemplo
// import apiTest from '../api/coins/coins-20.json'
// const listCoins = apiTest.data.coins;


function renderInput(inputProps) {
    const { InputProps, classes, ref, ...other } = inputProps;


    return (
        <TextField
            InputProps={{
                inputRef: ref,
                classes: {
                    root: classes.inputRoot,
                    input: classes.inputInput,
                },
                ...InputProps,
            }}
            {...other}
        />
    );
}

function renderSuggestion(suggestionProps) {
    const { suggestion, index, itemProps, highlightedIndex } = suggestionProps;
    const isHighlighted = highlightedIndex === index;
    // const isSelected = (selectedItem || '').indexOf(suggestion.name) > -1;

    return (
        <MenuItem
            {...itemProps}
            key={index}
            selected={isHighlighted}
            component="div"
            style={{
                // fontWeight: isSelected ? 500 : 400,
                fontWeight: 400,
            }}
        >
            <img src={suggestion.iconUrl} alt={suggestion.name} width='20' style={{ marginRight: 10 }} />
            {suggestion.name}
        </MenuItem>
    );
}
renderSuggestion.propTypes = {
    highlightedIndex: PropTypes.number,
    index: PropTypes.number,
    itemProps: PropTypes.object,
    selectedItem: PropTypes.string,
    suggestion: PropTypes.shape({ name: PropTypes.string }).isRequired,
};

function getSuggestions(list, value, { showEmpty = false } = {}) {
    // const inputValue = deburr(value.trim()).toLowerCase();
    const inputValue = value.trim().toLowerCase();
    
    const inputLength = inputValue.length;
    let count = 0;



    return inputLength === 0 && !showEmpty
        ? []
        : list.allCoins.filter((suggestion, index) => {
            const keep =
                count < 5 && suggestion.name.slice(0, inputLength).toLowerCase() === inputValue;

            if (keep) {
                count += 1;
            }

            return keep;
        });
}

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        height: 250,
    },
    container: {
        flexGrow: 1,
        position: 'relative',
    },
    paper: {
        // position: 'absolute',
        zIndex: 100000,
        marginTop: theme.spacing(1),
        left: 0,
        right: 0,
    },
    chip: {
        margin: theme.spacing(0.5, 0.25),
    },
    inputRoot: {
        flexWrap: 'wrap',
    },
    inputInput: {
        width: 'auto',
        flexGrow: 1,
    },
    divider: {
        height: theme.spacing(2),
    },
}));

export default function IntegrationDownshift({ coin, setCoin }) {
    const classes = useStyles();

    const [coins, setCoins] = React.useState();
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [erroApi, setErroApi] = React.useState(null);


    React.useEffect(() => {
        let isSubscribed = true
        api.coins('USD')
            .then(
                (result) => {
                    // console.log(result);
                    
                    if (isSubscribed) {
                        setIsLoaded(true)
                        setCoins(result)
                    }
                })
            .catch(error => {
                if (isSubscribed) {
                    setIsLoaded(true)
                    setErroApi(error)
                    console.log("Algum erro de conexão: ", error)
                }
            })
        return () => isSubscribed = false
    }, [])

    return (
        <Downshift
            id="downshift-simple"
            disabled
            initialSelectedItem={coin}
            onSelect={(selection, stateAndHelpers) =>
                setCoin(selection)
                // alert(`Selecionado ${selection} - ${JSON.stringify(stateAndHelpers, null, 2)}`)
            }
            itemToString={item => (item ? item.name : '')}
        >
            {({
                getInputProps,
                getItemProps,
                getLabelProps,
                getMenuProps,
                highlightedIndex,
                inputValue,
                isOpen,
                selectedItem,
            }) => {
                const { onBlur, onFocus, ...inputProps } = getInputProps({
                    placeholder: !isLoaded ? 'Encontrando...' : erroApi ? 'Parece que você esta sem conexão' : 'Escolha uma moeda'
                });


                return (
                    <div className={classes.container}>
                        {renderInput({
                            fullWidth: true,
                            classes,
                            label: 'Moeda',
                            InputLabelProps: getLabelProps({ shrink: true }),
                            InputProps: { onBlur, onFocus },
                            inputProps,
                            disabled: !isLoaded || erroApi ? true : false
                        })}

                        <div {...getMenuProps()} >
                            {isOpen ? (
                                <Paper className={classes.paper} square  >
                                    {getSuggestions(coins, inputValue).map((suggestion, index) =>
                                        renderSuggestion({
                                            suggestion,
                                            index,
                                            itemProps: getItemProps({ item: suggestion }),
                                            highlightedIndex,
                                            selectedItem,
                                        }),
                                    )}
                                </Paper>
                            ) : null}
                        </div>
                    </div>
                );
            }}
        </Downshift >
    );
}